export function About() {
  return (
    <section className="bg-white py-10 px-4 sm:py-16 sm:px-6 md:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="bg-cyan-400 border-4 border-black p-5 sm:p-8 md:p-12 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] sm:shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] md:shadow-[20px_20px_0px_0px_rgba(0,0,0,1)] relative">
          <div className="absolute -top-3 -left-3 w-8 h-8 sm:-top-4 sm:-left-4 sm:w-12 sm:h-12 bg-orange-600 rotate-45 border-4 border-black" />
          <p className="text-lg min-[400px]:text-xl sm:text-3xl md:text-4xl font-black leading-snug sm:leading-relaxed text-center">
            Allier créativité graphique et expertise technique. Je vous accompagne de l'idée au déploiement pour mettre en valeur votre activité.
          </p>
          <div className="absolute -bottom-3 -right-3 w-6 h-6 sm:-bottom-4 sm:-right-4 sm:w-8 sm:h-8 bg-violet-600 rounded-full border-4 border-black" />
        </div>
      </div>
    </section>
  );
}
